export const FulfillerModelModule = angular
    .module('app.services.model.models.fulfiller', [])
    .value('fulfillerModel', {
        name: 'String',
        id: 'String',
        email_contact: 'String',
        email_order: 'String',
        method: 'String',
        redirectUrl: 'String',
        redirectAppKey: 'String',
        phoneNumber: 'String',
        hasPhysicalAddress: 'Boolean',
        physicalAddress: {
            address1: 'String',
            address2: 'String',
            city: 'String',
            state: 'String',
            postalCode: 'String'
        },
        productCount: 'Number'
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/model/models/fulfiller.model.js